import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import toast from "react-hot-toast";

import useAxios from "services/useAxios.tsx";

import Loader from "utils/Loader";
import AddBrand from "components/brand/AddBrand";
import BrandItem from "components/brand/BrandItem";

export default function BrandManagement() {
  const { execute: getBrandApi } = useAxios("brand/Find_Brand");
  const { execute: deleteBrandApi } = useAxios("brand/Update_Brand");

  const [list, setList] = useState([]);
  const [updater, setUpdater] = useState(false);
  const [isLoading, setIsLoading] = useState([]);

  const deleteBrandFunc = (data) => {
    Swal.fire({
      text: "آیا از حذف این برند مطمئن هستید؟",
      showCancelButton: true,
      cancelButtonText: "انصراف",
      confirmButtonText: "تایید",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        deleteBrandApi({
          keyvalues: "status,-1",
          conditions: `id/=/${data?.id}`,
        }).then((res) => {
          if (res?.status == 1) {
            toast.success("حذف با موفقیت انجام شد.");
            setUpdater((prev) => !prev);
          } else {
            toast.error("متاسفانه مشکلی پیش آمده است لطفا مجدد تلاش کنید.");
          }
        });
      }
    });
  };

  useEffect(() => {
    async function loadPage(params) {
      setIsLoading(true);
      await getBrandApi({
        tbl_name: "left join,files,iconpic,id",
        conditions: "brand.status/=/0",
      }).then((res) => {
        setList(res);
      });
      setIsLoading(false);
    }
    loadPage();
  }, [updater]);

  return isLoading ? (
    <Loader />
  ) : (
    <div>
      <AddBrand setUpdater={setUpdater} />
      <div className="d-flex flex-wrap align-items-center m-2">
        {list?.length > 0 ? (
          list?.map((value, index) => (
            <BrandItem
              key={index}
              data={value}
              deleteBrandFunc={deleteBrandFunc}
            />
          ))
        ) : (
          <p className="font-16-700 mt-2 tex-center mx-auto">
            برند ثبت شده ای وجود ندارد.
          </p>
        )}
      </div>
    </div>
  );
}
